import { keyframes } from 'styled-components';
export default keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);